import React from "react";
import { useSelector } from "react-redux";

interface CommonModalProps {
  show: boolean;
  onClose: () => void;
  modalType?:
    | "background"
    | "copyReport"
    | "deleteReport"
    | "disputeReport"
    | "stopReport";
}

const CommonModal = ({
  show,
  onClose,
  modalType = "background",
}: CommonModalProps) => {
  const reduxDashboardData = useSelector(
    (state: any) => state?.dashboard?.dashboardData,
  );
  if (!show) return null;

  return (
    <div
      className="modal d-block"
      tabIndex={-1}
      style={{ background: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div
          className="modal-content"
          style={{
            borderRadius: "20px",
            overflow: "hidden",

            border: "none",
            boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
          }}
        >
          {/* BACKGROUND PACKAGE MODAL */}
          {modalType === "background" && (
            <div
              className="modal-body text-center"
              style={{
                borderRadius: "20px",
                overflow: "hidden",
                padding: "32px 28px",
                borderTop: "5px solid #d2660d",
                borderBottom: "5px solid #d2660d",
              }}
            >
              <div
                style={{
                  width: "52px",
                  height: "52px",
                  borderRadius: "14px",
                  background: "#fef0e6",
                  color: "#d2660d",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto 16px",
                  fontSize: "22px",
                }}
              >
                <i className="ti ti-clipboard-check"></i>
              </div>

              <h4
                style={{
                  fontSize: "20px",
                  fontWeight: 700,
                  color: "#2b1a0f",
                  marginBottom: "6px",
                }}
              >
                Background Check Package
              </h4>

              <p
                style={{
                  fontSize: "13.5px",
                  color: "#a8826e",
                  marginBottom: "20px",
                }}
              >
                The checks included in your verification package
              </p>

              <div
                style={{
                  textAlign: "left",
                  border: "1px solid #f5e3d4",
                  borderRadius: "12px",
                  overflow: "hidden",
                  marginBottom: "20px",
                }}
              >
                {reduxDashboardData?.checks?.map(
                  (checkData: any, index: any) => (
                    <div
                      key={index}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        padding: "12px 16px",
                        backgroundColor:
                          index % 2 === 0 ? "#fffaf6" : "#ffffff",
                        borderBottom:
                          index !==
                          (reduxDashboardData?.checks?.length ?? 0) - 1
                            ? "1px solid #f5e3d4"
                            : "none",
                      }}
                    >
                      <span
                        style={{
                          flexShrink: 0,
                          width: "22px",
                          height: "22px",
                          borderRadius: "50%",
                          background: "#fef0e6",
                          color: "#d2660d",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: "12px",
                        }}
                      >
                        <i className="ti ti-check"></i>
                      </span>
                      <span
                        style={{
                          fontSize: "14.5px",
                          fontWeight: 600,
                          color: "#2b1a0f",
                        }}
                      >
                        {checkData.check_name}
                      </span>
                    </div>
                  ),
                )}
              </div>

              <p
                style={{
                  fontSize: "13px",
                  lineHeight: "1.8",
                  color: "#6b5547",
                  background: "#fffaf6",
                  border: "1px solid #f5e3d4",
                  borderRadius: "10px",
                  padding: "12px 16px",
                  textAlign: "left",
                  marginBottom: "20px",
                }}
              >
                <b style={{ color: "#2b1a0f" }}>Note:</b> You only need to fill
                in the checks displayed on the application, as certain checks
                are run without requiring additional information.
              </p>

              <button onClick={onClose} className="btn btn-primary px-4">
                OK
              </button>
            </div>
          )}

          {/* COPY REPORT MODAL */}
          {modalType === "copyReport" && (
            <div className="modal-body p-4">
              <h5 className="text-center fw-bold text-decoration-underline mb-4">
                Obtain a copy of my report
              </h5>

              <ol style={{ lineHeight: "1.9" }}>
                <li className="fw-bold text-decoration-underline">
                  The right to access: How do I obtain a copy of my report?
                </li>

                <div className="ms-3 mt-2">
                  <p className="mb-2">
                    I. Contact Aupertz Support Team at
                    <br />
                    candidatesupport@aupertz.co.in / candidatesupport@aupertz.co.in with
                    the below mentioned details.
                  </p>

                  <ul>
                    <li>Complete Name</li>
                    <li>Date of Birth</li>
                    <li>Background Screening Employer</li>
                    <li>Home address</li>
                    <li>ID Proof</li>
                  </ul>

                  <h6 className="fw-bold">OR</h6>

                  <p>Note: Request you to enclose a copy of your ID proof.</p>

                  <p>
                    II. Request your Employer to share copy of your report with
                    you.
                  </p>
                </div>

                <li className="fw-bold text-decoration-underline mt-3">
                  The right to data portability: How do I ask for my data in a
                  machine readable format?
                </li>

                <div className="ms-3 mt-2">
                  <p className="mb-2">
                    I. Contact Aupertz Support Team at
                    <br />
                    candidatesupport@aupertz.co.in / candidatesupport@aupertz.co.in with
                    the below mentioned details.
                  </p>

                  <ul>
                    <li>Complete Name</li>
                    <li>Date of Birth</li>
                    <li>Background Screening Employer</li>
                    <li>Home address</li>
                    <li>ID Proof</li>
                  </ul>
                </div>
              </ol>

              <div className="text-center mt-4">
                <button
                  className="btn btn-outline-primary px-5"
                  onClick={onClose}
                >
                  Close
                </button>
              </div>
            </div>
          )}

          {/* DELETE REPORT MODAL */}
          {modalType === "deleteReport" && (
            <div className="modal-body p-4">
              <h5 className="text-center fw-bold text-decoration-underline mb-4">
                Delete my data/report
              </h5>

              <ol style={{ lineHeight: "1.9" }}>
                <li className="fw-bold text-decoration-underline">
                  The right to erase: How do I ask for my data to be deleted ?
                </li>

                <div className="ms-3 mt-2">
                  <p className="mb-2">
                    I. Contact Aupertz Support Team at
                    <br />
                    candidatesupport@aupertz.co.in / candidatesupport@aupertz.co.in with
                    the below mentioned details.
                  </p>

                  <ul>
                    <li>Complete Name</li>
                    <li>Date of Birth</li>
                    <li>Background Screening Employer</li>
                    <li>Home address</li>
                    <li>ID Proof</li>
                  </ul>

                  <p className="mt-3">
                    Note: Request you to enclose a copy of your ID proof.
                  </p>
                </div>
              </ol>

              <div className="text-center mt-4">
                <button
                  className="btn btn-outline-primary px-5"
                  onClick={onClose}
                >
                  Close
                </button>
              </div>
            </div>
          )}
          {/* DISPUTE REPORT MODAL */}
          {modalType === "disputeReport" && (
            <div className="modal-body p-4">
              <h5 className="text-center fw-bold text-decoration-underline mb-4">
                Dispute my report
              </h5>

              <ol style={{ lineHeight: "1.9" }}>
                <li className="fw-bold text-decoration-underline">
                  The right to rectification: The information in my report is
                  not correct, how do I dispute it ?
                </li>

                <div className="ms-3 mt-2">
                  <p className="mb-2">
                    I. Contact Aupertz Support Team at
                    candidatesupport@aupertz.co.in / candidatesupport@aupertz.co.in with
                    the below mentioned details.
                  </p>

                  <ul>
                    <li>Complete Name</li>
                    <li>Date of Birth</li>
                    <li>Background Screening Employer</li>
                    <li>Home address</li>
                    <li>ID Proof</li>

                    <li>
                      Error/Issue summary(Check Details (Employment, Education,
                      Address) with respective page number in the report
                    </li>

                    <li>(Attach copies to support your claim)</li>
                  </ul>
                </div>

                <li className="fw-bold mt-3">
                  In case of dispute resolution, Aupertz will follow below
                  process:
                </li>

                <ul className="mt-2">
                  <li>
                    We will investigate the item(s) in question — usually within
                    30 days. Include copies (NOT originals) of documents that
                    support your position. In addition to providing your details
                    as mentioned above:
                  </li>

                  <ul className="mt-2">
                    <li>
                      Clearly identify each item in your report you dispute.
                    </li>

                    <li>
                      State the facts and explain why you dispute the
                      information
                    </li>

                    <li>Request deletion or correction</li>
                  </ul>

                  <li className="mt-3">
                    Send your dispute by email on the Email Id mentioned above
                    and you will receive an acknowledgement number from us.
                    Please keep it for future correspondences.
                  </li>

                  <li className="mt-3 fw-bold">Disclaimer:</li>

                  <li>
                    We will re-verify the information with the source and if
                    there is any change at the source's end, we will provide you
                    the updated information, as applicable.The correction,
                    amendment of the information is at the sole discretion of
                    the source.
                  </li>
                </ul>
              </ol>

              <div className="text-center mt-4">
                <button
                  className="btn btn-outline-primary px-5"
                  onClick={onClose}
                >
                  Close
                </button>
              </div>
            </div>
          )}

          {/* STOP REPORT MODAL */}
          {modalType === "stopReport" && (
            <div className="modal-body p-4">
              <h5 className="text-center fw-bold text-decoration-underline mb-4">
                Stop my report/Withdraw consent
              </h5>

              <ol style={{ lineHeight: "1.9" }}>
                <li className="fw-bold text-decoration-underline">
                  The right to restrict processing: How do I ask for a temporary
                  halt to process my data ?
                </li>

                <div className="ms-3 mt-2">
                  <p className="mb-2">
                    I. Contact Aupertz Support Team at
                    candidatesupport@aupertz.co.in / candidatesupport@aupertz.co.in with
                    the below mentioned details.
                  </p>

                  <ul>
                    <li>Complete Name</li>
                    <li>Date of Birth</li>
                    <li>Background Screening Employer</li>
                    <li>Home address</li>
                    <li>ID Proof</li>
                    <li>
                      Reason of stop(Not joining the company / Don’t want to
                      share/ Withdraw consent)
                    </li>
                  </ul>
                </div>

                <li className="fw-bold text-decoration-underline mt-3">
                  The right to object: How to I ask object to further processing
                  of my data which is inconsistent with the primary purpose ?
                </li>

                <div className="ms-3 mt-2">
                  <p className="mb-2">
                    I. Contact Aupertz Support Team at
                    <br />
                    candidatesupport@aupertz.co.in / candidatesupport@aupertz.co.in with
                    the below mentioned details.
                  </p>

                  <ul>
                    <li>Complete Name</li>
                    <li>Date of Birth</li>
                    <li>Background Screening Employer</li>
                    <li>Home address</li>
                    <li>ID Proof</li>
                  </ul>
                  <p>If you want to stop or delete your data.</p>
                  <ul>
                    <li>
                      Action 1: If you want to stop the processing of your data,
                      it can be resumed at a later stage.
                    </li>
                    <li>
                      Action 2: If you want to delete the data, it cannot be
                      retrieved again.
                    </li>
                  </ul>
                </div>
              </ol>

              <div className="text-center mt-4">
                <button
                  className="btn btn-outline-primary px-5"
                  onClick={onClose}
                >
                  Close
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CommonModal;
// import React from "react";

// interface CommonModalProps {
//   show: boolean;
//   onClose: () => void;
// }

// const CommonModal = ({
//   show,
//   onClose,
// }: CommonModalProps) => {
//   if (!show) return null;

//   return (
//     <div className="modal d-block" tabIndex={-1} style={{ background: "rgba(0,0,0,0.5)" }}>
//       <div className="modal-dialog modal-dialog-centered">
//         <div className="modal-content border-0">

//           <div className="modal-body text-center p-4">

//             <h4 className="mb-4">
//               Background Check Package
//             </h4>

//             <table className="table table-bordered text-center">
//               <tbody>
//                 <tr>
//                   <td>PAN</td>
//                 </tr>

//                 <tr>
//                   <td>1 Highest Education</td>
//                 </tr>

//                 <tr>
//                   <td>Last 5 Years Employment</td>
//                 </tr>

//                 <tr>
//                   <td>OFAC</td>
//                 </tr>

//                 <tr>
//                   <td>AADHAAR NUMBER</td>
//                 </tr>
//               </tbody>
//             </table>

//             <p
//               className="mt-3"
//               style={{ lineHeight: "1.8" }}
//             >
//               <b>Note:</b> You only need to fill in the checks
//               displayed on the application, as certain checks are
//               run without requiring additional information.
//             </p>

//             <button
//               className="btn btn-outline-primary px-5 mt-2"
//               onClick={onClose}
//             >
//               OK
//             </button>

//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CommonModal;
